import { useState } from "react";

export default function TouchCategorizationExercise({ data, categories = [], topic = "", freeForm = false }) {
  const filteredData = topic ? data.filter(item => item.topic === topic) : data;

  const uniqueCategories = categories.length > 0 ? categories : [
    ...new Set(filteredData.map(item => item.category))
  ];

  const [categorizedWords, setCategorizedWords] = useState({});
  const [selectedWord, setSelectedWord] = useState(null);

  const handleWordClick = (word) => {
    setSelectedWord(word === selectedWord ? null : word); // toggle
  };

  const handleCategoryClick = (category) => {
    if (!selectedWord) return;

    if (freeForm) {
      // Free‑form mode: accept any category the student chooses
      setCategorizedWords(prev => ({
        ...prev,
        [selectedWord]: category
      }));
    } else {
      // Original behavior: only accept the correct category
      const correctCategory = filteredData.find(
        item => item.word === selectedWord
      )?.category;

      if (correctCategory === category) {
        setCategorizedWords(prev => ({
          ...prev,
          [selectedWord]: category
        }));
      }
    }

    setSelectedWord(null); // reset selection
  };

  const handleDropWordClick = (word) => {
    setCategorizedWords(prev => {
      const next = { ...prev };
      delete next[word];
      return next;
    });
  };

  const resetExercise = () => {
    setCategorizedWords({});
    setSelectedWord(null);
  };

  return (
    <div>
      <button onClick={resetExercise} className="reset-button">Reset</button>
      <div className="exercise-container">
        <div className="vocabcolumn-container">
          {filteredData.map(item => (
            !categorizedWords[item.word] && (
              <div
                key={item.word}
                onClick={() => handleWordClick(item.word)}
                className={`draggable-word ${selectedWord === item.word ? "selected" : ""}`}
                style={{
                  padding: "8px 12px",
                  border: "2px solid #6a4bc3",
                  borderRadius: 20,
                  background: selectedWord === item.word ? "#6a4bc3" : "#fff",
                  color: selectedWord === item.word ? "#fff" : "#000",
                  cursor: "pointer",
                  fontWeight: 600,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.2s ease",
                  userSelect: "none",
                  textAlign: "center",
                  margin: "4px",
                  width: "fit-content",
                  display: "inline-block",
                }}
              >
                {item.word}
              </div>
            )
          ))}
        </div>

        <div className="categories-container" style={{ display: "flex", justifyContent: "space-around" }}>
          {uniqueCategories.map(category => (
              <div
                key={category}
                className="category-column"
                onClick={() => handleCategoryClick(category)}
                style={{
                  padding: "10px",
                  border: "2px solid #333",
                  borderRadius: 12,
                  width: "200px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  userSelect: "none",
                  background: "#fff",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "#f0f0f0"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; }}
              >
              <h3>{category}</h3>
              <div className="dropped-words">
                {filteredData
                  .filter(item => categorizedWords[item.word] === category)
                  .map(item => (
                    <div
                      key={item.word}
                      onClick={() => handleDropWordClick(item.word)}
                      className="categorized-word"
                      style={{
                        margin: "5px",
                        padding: "5px",
                        border: "1px solid #6a4bc3",
                        borderRadius: 12,
                        background: "#fff",
                        color: "#000",
                        cursor: "pointer",
                        fontWeight: 600,
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        transition: "all 0.2s ease",
                        userSelect: "none",
                        textAlign: "center",
                        width: "fit-content",
                        display: "inline-block",
                      }}
                    >
                      {item.word}
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
